import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useQueryParams } from 'utils/useQueryParams';

// @ts-ignore
import { getCookie } from 'utils/StorageVariables';

import {
  Wrapper,
  Content
} from './styled';

import Header from './Header';
import OverallTrend from './OverallTrend';
import DetailedTrends from './DetailedTrends';
import Placeholder from './Placeholder';
import { DateType, getDateType } from './LineChart';

// @ts-ignore
import { ListDomain } from "Redux/ListDomains/action";

import { GetOverallProgress } from "Redux/Achievements/ListOverallProgress/action";
import { GetMasterProgress } from 'Redux/Achievements/ListMasterProgress/action';
import { GetHistoricalData } from 'Redux/Achievements/ListHistoricalData/action';

interface IState {
  domainListReducer: {
    loading: boolean;
    domainList: any;
  }
  globalReducer: {
    SelectedClient: any;
  }
}

const Achievements = () => {
  const dispatch = useDispatch();

  const { journey: journeyId, area: areaName, start, end, setQueryParams } = useQueryParams();

  const { domainList, loading } = useSelector((state: IState) => state.domainListReducer);
  const { SelectedClient } = useSelector((state: IState) => state.globalReducer);

  const [masterPlanId, setMasterPlanId] = useState<string | null>(null);
  const [prevClientId, setPrevClientId] = useState<string | null>(null);

  useEffect(() => {
    const selectedClient = getCookie("selectedClient");
    const currentClientId = SelectedClient?.id || null;
    
    // Only reset filters when the client actually changes
    if (prevClientId !== null && prevClientId !== currentClientId) {
      // We're using setTimeout to break the render cycle and avoid infinite loop
      setTimeout(() => {
        setQueryParams({
          journey: undefined,
          area: undefined,
          start: undefined,
          end: undefined
        });
      }, 0);
    }
    
    // Update the previous client ID
    setPrevClientId(currentClientId);
    
    if (selectedClient && SelectedClient) {
      dispatch(ListDomain(SelectedClient?.id));
      dispatch(GetMasterProgress({ client_id: SelectedClient?.id }));
    } else {
      dispatch(ListDomain());
      dispatch(GetMasterProgress());
    }
  }, [SelectedClient]);
  
  useEffect(() => {
    const domain = domainList.find((d: any) => d.id === journeyId);

    if (domain) {
      const masterPlanId = domain.current_state?.id;
      setMasterPlanId(masterPlanId);
    }
    else {
      setMasterPlanId(null);
    }
  }, [domainList, journeyId, SelectedClient]);

  useEffect(() => {
    let selectedClient = getCookie("selectedClient");
    
    dispatch(GetOverallProgress({
      ...(masterPlanId && { domain: masterPlanId }),
      ...(areaName && { area: areaName }),
      ...(selectedClient && SelectedClient && { client_id: SelectedClient?.id })
    }));
  }, [masterPlanId, areaName, SelectedClient]);

  useEffect(() => {
    const dateType = start && end ? getDateType(start, end) : DateType.WEEKLY;
    let selectedClient = getCookie("selectedClient");

    if (start && end) {
      dispatch(GetHistoricalData({
        ...(masterPlanId && { domain: masterPlanId }),
        ...(areaName && { area: areaName }),
        ...(selectedClient && SelectedClient && { client_id: SelectedClient?.id }),
        start_date: start,
        end_date: end,
        type: dateType,
      }));
    }
  }, [masterPlanId, areaName, start, end, SelectedClient]);

  if (loading)
    return;

  if (!domainList.filter((d: any) => d.current_state.status !== "Not started").length)
    return <Placeholder />;

  return (
    <Wrapper>
      <Header />

      <Content>
        <OverallTrend />
        <DetailedTrends />
      </Content>
    </Wrapper>
  );
}

export default Achievements;
